import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Chip, SectionHeader, Loading, EmptyState } from "@/components/brand";
import { ClassCard } from "@/components/cards";

const LEVELS = [["all", "All levels"], ["beginner", "Beginner"], ["intermediate", "Intermediate"], ["advanced", "Advanced"]];

export default function Classes() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [level, setLevel] = useState("all");
  const cats = useQuery({ queryKey: ["categories"], queryFn: () => api("/categories") });
  const q = new URLSearchParams();
  if (category) q.set("category", category);
  if (level !== "all") q.set("level", level);
  const classes = useQuery({ queryKey: ["classes", { category, level }], queryFn: () => api(`/classes?${q.toString()}`) });

  const setCat = (c) => { const p = new URLSearchParams(params); if (c) p.set("category", c); else p.delete("category"); setParams(p); };

  return (
    <div data-testid="classes-screen" className="space-y-5">
      <SectionHeader title="Live Classes" subtitle="Book a live group session with a real coach." />
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
        <Chip label="All" selected={!category} onClick={() => setCat("")} testID="class-cat-all" />
        {(cats.data ?? []).map((c) => <Chip key={c.key} label={c.name} selected={category === c.key} onClick={() => setCat(c.key)} testID={`class-cat-${c.key}`} />)}
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {LEVELS.map(([k, l]) => <Chip key={k} label={l} selected={level === k} onClick={() => setLevel(k)} testID={`class-level-${k}`} />)}
      </div>
      {classes.isLoading ? <Loading /> : (classes.data ?? []).length === 0 ? (
        <EmptyState title="No classes found" subtitle="Try a different category or level." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">{(classes.data ?? []).map((c) => <ClassCard key={c.id} item={c} />)}</div>
      )}
    </div>
  );
}
